import { Fragment } from 'react';
import { MdOutlineError } from 'react-icons/md';
import { toast } from 'react-toastify';
export const toastRequestFailed = (error) => {
    toast.success(<Fragment>{error.message}</Fragment>, {
        icon: (<MdOutlineError color='red' size={'lg'}/>),
    });
};
